import { UserType } from '../components/context/SignupContext';

/**
 * Display name mapping for profile types
 * Only used for UI display - all internal IDs and data flow remain unchanged
 */
export const getProfileDisplayName = (userType: UserType | null | undefined): string => {
  if (!userType) return '';
  
  const displayNames: Record<UserType, string> = {
    'creator': 'Creative Campaign Manager',
    'influencer': 'Influencer & Creator', 
    'artist': 'Human Artist'
  };
  
  return displayNames[userType] || userType;
};
//code
/**
 * Get display title for onboarding/signup (slightly different format)
 */
export const getProfileDisplayTitle = (userType: UserType | null | undefined): string => {
  if (!userType) return '';
  
  const displayTitles: Record<UserType, string> = {
    'creator': 'Creative Campaign Manager',
    'influencer': 'Influencers and Creators',
    'artist': 'Human Artist'
  };
  
  return displayTitles[userType] || userType;
};

